(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artfaq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.art-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.art-faq__item');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
      btn.nextElementSibling.setAttribute('aria-hidden', String(isOpen));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pda-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.pda-item');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
      btn.nextElementSibling.setAttribute('aria-hidden', String(isOpen));
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
